<template>
  <USPaymentAdvertisement
    v-if="isEnabled"
    :methods="selectedOffer?.paymentMethods"
  />
  <AdvertisedPayment v-else :price :selected-offer />
</template>

<script setup lang="ts">
import type { Price } from '@backmarket/http-api/src/api-models/Price'
import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import AdvertisedPayment from '~/scopes/product-core/components/presentationals/AdvertisedPayment/AdvertisedPayment.vue'

import USPaymentAdvertisement from '../USPaymentAdvertisement/USPaymentAdvertisement.vue'

const experiments = useExperiments()
const isEnabled =
  experiments['experiment.ppUSPaymentAdvertisement'] ===
  'withUSPaymentAdvertisement'

defineProps<{
  price: Price
  selectedOffer: GetPickersResponse['selectedOffer'] | null
}>()
</script>
